import React from 'react'
import Button from '../Button'

export const HostingProps = ({ heading, paragraph, img }) => {
    return (
        <div className='w-full flex lg:flex-row flex-col justify-between items-center gap-3 p-2 border-[1px] border-[#363535] rounded-lg'>
            <div data-aos="fade-right" className='lg:w-[40%] w-full lg:pl-[30px] lg:items-start items-center gap-3 flex flex-col lg:gap-4'>
                <p className='lg:text-[29px] text-[16px] font-bold text-white'>{heading}</p>
                <p className='lg:text-[14px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
                <Button
                    title={"Buy Now"}
                    link={"/"}
                />
            </div>
            <div className='flex justify-end'>
                <img width={700} height={600} className='lg:w-full md:h-[90%]' data-aos="fade-left" src={img} alt="" />
            </div>
        </div>
    )
}
export const HostingPropsnew = ({ heading, paragraph, img }) => {
    return (
        <div className='w-full flex lg:flex-row flex-col justify-between items-center gap-3 p-2 border-[1px] border-[#363535] rounded-lg'>
            <div data-aos="fade-right" className='lg:w-[50%] w-full lg:pl-[30px] lg:items-start items-center gap-3 flex flex-col lg:gap-4'>
                <p className='lg:text-[29px] text-[16px] font-bold text-white'>{heading}</p>
                <p className='lg:text-[14px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
                <Button
                    title={"Buy Now"}
                    link={"/"}
                />
            </div>
            <div className='lg:w-[50%] w-full'>
                <img data-aos="fade-left" src={img} alt="" />
            </div>
        </div>
    )
}
export const HostingProps2 = ({ heading, paragraph, img }) => {
    return (
        <div className='w-full flex lg:flex-row flex-col gap-3 justify-between items-center p-2 border-[1px] border-[#363535] rounded-lg'>
            <div className='lg:w-[50%] w-full'>
                <img width={600} className='rounded-lg' data-aos="fade-right" src={img} alt="" />
            </div>
            <div data-aos="fade-left" className='lg:w-[45%] lg:items-start items-center lg:pl-[30px] flex flex-col gap-4'>
                <p className='lg:text-[29px] text-[16px] lg:text-start text-center font-bold text-white'>{heading}</p>
                <p className='lg:text-[14px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
                <Button
                    title={"Buy Now"}
                    link={"/"}
                />
            </div>
        </div>
    )
}
export const HostingProps3 = ({ heading, paragraph, img }) => {
    return (
        <div className='w-full flex lg:flex-row flex-col gap-3 justify-between items-center p-2 border-[1px] border-[#363535] rounded-lg'>
            <div data-aos="fade-left" className='lg:w-[45%] lg:items-start items-center lg:pl-[30px] flex flex-col gap-4'>
                <p className='lg:text-[29px] text-[16px] lg:text-start text-center font-bold text-white'>{heading}</p>
                <p className='lg:text-[14px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
                <Button
                    title={"Buy Now"}
                    link={"/"}
                />
            </div>
            <div className='lg:w-[50%] w-full flex justify-end'>
                <img width={600} className='rounded-lg' data-aos="fade-right" src={img} alt="" />
            </div>
        </div>
    )
}
